import { mutatorAction } from 'satcheljs';
import { getCollabSpaceStore } from '../store/store';

export const initializeStore = mutatorAction('initializeStore', (viewStateId: string) => {
    if (!viewStateId) {
        return;
    }

    const storeCollection = getCollabSpaceStore().entries;
    if (!storeCollection.has(viewStateId)) {
        storeCollection.set(viewStateId, {
            shareLink: null,
            fileName: null,
            isCollabSpacePresent: false,
            collabAllowed: null,
            isShared: null,
            isNewDoc: false,
            fluidLinkFailed: false,
            isCollabSpaceExplicitlyDisabled: false,
            seriesMasterShareLink: null,
            seriesInstanceShareLink: null,
            creationSource: null,
        });
    }
});
